const CURRENCY = 'currency';

const formatPrice = function(rawPrice, locale, currency = 'USD', formattingOptions = {
  leadingCurrency: false
}) {
  const options = {
    style: CURRENCY,
    currency: currency,
    minimumFractionDigits: 2
  };

  const formatter = new Intl.NumberFormat(locale, options);
  const price = parseFloat(rawPrice);

  if (formattingOptions.leadingCurrency) {
    const localedCurrency = formatter.formatToParts(price).find(({ type }) => type === CURRENCY).value;
    const purePrice = formatter.format(price).replace(localedCurrency, '').trim();

    return localedCurrency + purePrice;
  }

  return formatter.format(price);
};

export default formatPrice;
